import { useState } from 'react';
import { VARIABLE_MAX } from '../constants';

export function VariableHeatmapRows({ vars, topVar, bottomVar }: {
  vars: { name: string; score: number }[];
  topVar: string | undefined;
  bottomVar: string | undefined;
}) {
  const [hoveredVar, setHoveredVar] = useState<string | null>(null);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {vars.map((v) => {
        const fillPct = (v.score / VARIABLE_MAX) * 100;
        const isTop = v.name === topVar;
        const isBottom = v.name === bottomVar;
        const isHovered = hoveredVar === v.name;

        return (
          <div key={v.name} style={{ display: 'grid', gridTemplateColumns: '210px 1fr 96px', alignItems: 'center', gap: '16px' }}>
            <span style={{ fontSize: 'var(--text-sm)', color: 'var(--foreground)' }}>{v.name}</span>

            {/* Bar with tooltip */}
            <div
              style={{ position: 'relative' }}
              onMouseEnter={() => setHoveredVar(v.name)}
              onMouseLeave={() => setHoveredVar(null)}
            >
              <div style={{ height: '10px', borderRadius: '99px', backgroundColor: 'var(--muted)', position: 'relative', overflow: 'hidden', cursor: 'default' }}>
                <div style={{
                  position: 'absolute', left: 0, top: 0, bottom: 0,
                  width: `${fillPct}%`,
                  borderRadius: '99px',
                  backgroundColor: '#00c9c4',
                  opacity: isHovered ? 0.8 : 1,
                  transition: 'opacity 0.15s',
                }} />
              </div>
              {isHovered && (
                <div style={{
                  position: 'absolute',
                  bottom: '18px',
                  left: `${Math.min(fillPct, 88)}%`,
                  transform: 'translateX(-50%)',
                  backgroundColor: 'var(--foreground)',
                  color: 'var(--background)',
                  fontSize: 'var(--text-xs)',
                  fontWeight: 600,
                  padding: '4px 8px',
                  borderRadius: '5px',
                  whiteSpace: 'nowrap',
                  pointerEvents: 'none',
                  zIndex: 10,
                }}>
                  {Math.round((v.score / VARIABLE_MAX) * 100)} / 100
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 0, height: 0,
                    borderLeft: '4px solid transparent',
                    borderRight: '4px solid transparent',
                    borderTop: '4px solid var(--foreground)',
                  }} />
                </div>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {isTop && (
                <span style={{ fontSize: 'var(--text-xs)', fontWeight: 600, color: '#00c9c4', backgroundColor: '#e1fdfd', border: '1px solid rgba(0,201,196,0.3)', borderRadius: '4px', padding: '2px 8px', whiteSpace: 'nowrap' }}>
                  Strongest
                </span>
              )}
              {isBottom && (
                <span style={{ fontSize: 'var(--text-xs)', fontWeight: 600, color: '#ff6d66', backgroundColor: '#ffeaea', border: '1px solid rgba(255,109,102,0.3)', borderRadius: '4px', padding: '2px 8px', whiteSpace: 'nowrap' }}>
                  Priority gap
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
